import { Component } from '@angular/core';

@Component({
    templateUrl: './bidpoints-help.component.html',
    standalone: false
})
export class BidPointsHelpComponent { }
